import React, { useState } from 'react'
import { CustomModal } from '../../revampComponents/Atom/Modals';
import Dropdown from '../../revampComponents/Atom/Dropdown';
import Select from "react-select";
import warning from "../../assets/img/Models/warning.svg";
import FormButtons from '../../revampComponents/Molecule/Buttons/FormButtons';
import { successToaster, errorToaster, EVENT_ROLE_TYPE } from '../../reusable/common';
import { transferOwner } from '../../revampCRUD/organisers.crud';
import transferIconWhite from "../../assets/transfer-icon-white.svg"
import { dashboardColors, theme } from '../../themes/Theme';



const dropDownStyles = {
    option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        background: isSelected ? dashboardColors[theme].primary : undefined,
        margin: "0px",
        color: isSelected ? "white" : undefined,
        zIndex: 10,
        overflowX: "hidden",
        wordBreak: "break-word"
    }),
    menu: (provided, state) => ({
        ...provided,
        marginTop: "2px",
        overflow: "hidden",
        zIndex: 10,
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    dropdownIndicator: base => ({
        ...base,
        color: dashboardColors[theme].primaryTextColor,
        padding: "5px 8px",
        zIndex: 10,
        "&:hover": {
            color: dashboardColors[theme].primaryTextColor,
        }
    }),
    control: (base, state) => ({
        ...base,
        border: state.isFocused ? `1px solid ${dashboardColors[theme].primary}` : "1px solid #cdd4db",
        boxShadow: "none",
        borderRadius: "2px",
        zIndex: 10,
        minHeight: "36px"
        // width: "100%"
    })
};

const TransferOwnership = ({
    setOpenTransferOwner,
    openTransferOwner,
    eventId,
    organizerDetails,
    listOrganizerDetails
}) => {
    const [transferUser, setTransferUser] = useState('');
    const [Screen, setScreen] = useState('initial');
    const [loading, setLoading] = useState(false)
    const dropdownOption = organizerDetails => {
        const options = [];
        organizerDetails.map((val, index) => {
            if (val?.role_id !== EVENT_ROLE_TYPE?.EVENT_CREATOR && val?.role_id !== EVENT_ROLE_TYPE?.ADMIN_NO_DOWNLOADS && val?.user_id !== null) {
                options.push({
                    email: val?.organiser_email,
                    label: val?.organiser_name,
                    value: index,
                    userId: val?.user_id
                });
            }
        });
        return options;
    };

    const transferOwnerFunction = async () => {
        const payload = {
            role_id: 1,
            user_email: transferUser?.email
        }
        setLoading(true)
        try {
            const getResponse = await transferOwner(eventId, payload);
            if (getResponse?.status === 200) {
                successToaster(getResponse?.data);
                setOpenTransferOwner(false)
                listOrganizerDetails()
            } else {
                errorToaster("Something went wrong");
            }
        } catch (err) {
            errorToaster(err?.response?.data?.error);
            setOpenTransferOwner(false);
        }
        setLoading(false)
    }

    return (
        <>
            <CustomModal
                openModal={openTransferOwner}
                setOpenModal={setOpenTransferOwner}
                saveBtnContent={null}
                width={Screen == 'initial' ? "30%" : "35%"}
                content={
                    <div className="px-3">
                        {Screen == 'initial' && <>
                            <p className="title mb-2">
                                Transfer Event Ownership
                            </p>
                            <p className="sub-text">
                                You can transfer event ownership by choosing a member <br />from the list of signed-up admins
                            </p>
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <Select
                                        placeholder="Select Admin"
                                        options={dropdownOption(organizerDetails)}
                                        // value={formik.values.tax_country}
                                        onChange={(e) => {
                                            setTransferUser(e)
                                        }}
                                        styles={dropDownStyles}
                                        noOptionsMessage={() => 'No Admins available!'}
                                        menuPlacement="auto"
                                        menuPortalTarget={document.querySelector('body')}
                                    />
                                </div>
                                <div className="col-md-12 mt-4">
                                    <button
                                        className="save-btn"
                                        style={{ width: '100%' }}
                                        onClick={() => setScreen('confirmTransfer')}
                                        disabled={transferUser == ''}
                                    >
                                        <img src={transferIconWhite} alt="transfer-icon" />
                                        <span className="ml-2">Transfer Ownership</span>
                                    </button>
                                </div>
                            </div>
                        </>}
                        {Screen == 'confirmTransfer' && <>
                            <div className="text-center">
                                <div>
                                    <img
                                        src={warning}
                                        className="mb-3"
                                        style={{
                                            width: "4rem"
                                        }}
                                    />
                                </div>
                                <div className="mt-3 email-text">
                                    Are you sure you want to transfer the ownership of your <br /> event to {transferUser.email}?
                                </div>
                                <div className="warning-text mt-3">
                                    Please note that by doing so, your role will be changed to Admin, and you will no longer
                                    have access to certain sections like bank details for this event.
                                </div>
                            </div>
                            <div className="mt-4">
                                <FormButtons
                                    paddingRequired="no"
                                    onSave={transferOwnerFunction}
                                    onCancel={() => setOpenTransferOwner(false)}
                                    saveBtnContent={"Yes, transfer"}
                                    cancelBtnContent={"No"}
                                    saveBtnDisabled={loading}
                                />
                            </div>
                        </>}
                    </div>
                }
            />
            <style>{`
                .title{
                    font-family: Hind;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 500;
                    text-align: left;
                    color: ${dashboardColors[theme].primaryTextColor};
                }
                .sub-text{
                    font-family: Hind;
                    font-size: 14px;
                    font-weight: 400;
                    text-align: left;
                    color: ${dashboardColors[theme].primaryTextColor};
                }
                .email-text{
                    font-family: Hind;
                    font-size: 15px;
                    font-weight: 400;
                   color: ${dashboardColors[theme].primaryTextColor};
                }
                .warning-text{
                    border: 1px solid #E2E2E2;
                    border-radius: 5px;
                    padding: 17px;
                    background: #F8F8F8;
                    font-family: Hind;
                    font-size: 14px;
                    font-weight: 400;
                    color: #6C757D
                }
            `}</style>
        </>
    )
}

export default TransferOwnership
